// import { createTheme } from '@mui/material/styles';
// const theme = createTheme({
//     palette: {
//       primary: {
//         main: '#3c3759',
//       },
//       secondary: {
//         main: '#f50057',
//       },
//       background: {
//         default: '#f5f5f5',
//       },
//     },
//     typography: {
//       fontFamily: [
//         'Roboto',
//         'Arial',
//         'sans-serif',
//       ].join(','),
//       h4: {
//         fontWeight: 600,
//       },
//       h5: {
//         fontWeight: 600,
//       },
//     },
//     components: {
//       MuiPaper: {
//         styleOverrides: {
//           root: {
//             borderRadius: 8,
//           },
//         },
//       },
//       MuiCard: {
//         styleOverrides: {
//           root: {
//             borderRadius: 8,
//           },
//         },
//       },
//       MuiChip: {
//         styleOverrides: {
//           root: {
//             borderRadius: 4,
//             fontWeight: 500,
//           },
//         },
//       },
//     },
//   });
  
//   export default theme;

import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import type { ThemeOptions } from "@mui/material/styles";
import { foundations } from "./foundations";
import { components } from "./components";

const themeOptions: ThemeOptions = {
  ...foundations,
};

const theme = createTheme({
  ...themeOptions,
  components: {
    ...components,
  },
});

export default responsiveFontSizes(theme);